<template>
  <div class="zoox-component zoox-calendar">
    <v-sheet :height="height">
      <!--Evento emitido ao clicar em um evento do calendário
          @event click:event
          @property {Object} event - Objeto referente ao evento clicado
       -->

      <!--Evento emitido ao clicar na botão de "mais eventos" do calendário
          @event click:more
          @property {Array} events - Array de eventos colocados na data do calendário
       -->

      <!--Evento emitido ao clicar no dia do mês no calendário
          @event input
          @property {Object} dateObject - Objeto com informação sobre o data clicada
       -->
      <v-calendar
        ref="calendar"
        color="primary"
        :type="type"
        :value="value"
        :locale="locale"
        :events="events"
        :weekdays="[0, 1, 2, 3, 4, 5, 6]"
        @input="$emit('input', $event)"
        @click:event="$emit('click:event', $event)"
        @click:more="$emit('click:more', $event)"
      >
        <template #day> <br /></template>
      </v-calendar>
    </v-sheet>
  </div>
</template>

<script>
/**
 * @displayName Calendar
 */
export default {
  name: 'ZCalendar',
  props: {
    /**
     * Data no formato YYYY-MM-DD que determina o periodo de tempo do calendario
     */
    value: {
      type: [String, Number, Date],
      default: '',
    },
    /**
     * Array de eventos para aparecer no calendário
     *
     * @typedef  { name:string, start:date, end:date, color:string }
     */
    events: {
      type: Array,
      default: () => [],
    },
    /**
     * Locale do calendário
     */
    locale: {
      type: String,
      default: 'pt-br',
    },
    /**
     * Tipo de calendário
     */
    type: {
      type: String,
      default: 'month',
    },
    /**
     * Altura do calendário
     */
    height: {
      type: String,
      default: null,
    },
  },
  methods: {
    /**
     * @public
     *
     * Método para avançar uma view do calendário
     */
    next() {
      this.$refs.calendar.next()
    },
    /**
     * @public
     *
     * Método para voltar uma view do calendário
     */
    prev() {
      this.$refs.calendar.prev()
    },
  },
}
</script>

<style lang="scss">
.zoox-calendar {
  .v-calendar-weekly__head {
    border-bottom: 1px solid #cdcdcdcd;
  }
  .v-calendar-weekly .v-calendar-weekly__head-weekday {
    background-color: unset !important;
    font-size: 12px;
    font-weight: 700;
    color: unset;
    padding: 2px;
    &.v-past {
      color: unset;
    }
    &:not(:last-child) {
      border: none;
    }
  }
}
</style>
